import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { Alert } from "antd";
import styles from "./Table.module.less";
import React from "react";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const AppHeader = React.lazy(
  () => import("../components/layout/AppHeader/appHeader"),
);
const AppFooter = React.lazy(
  () => import("../components/layout/AppFooter/AppFooter"),
);
export function barraNotFound() {
  function notFound() {
    return (
      <>
        <div>
          <LazySuspense>
            <AppHeader />
          </LazySuspense>
          <div className={styles.contentStyle}>
            <Alert message={"La pagina no existe"} type={"info"} />
          </div>
        </div>
        <LazySuspense>
          <AppFooter />
        </LazySuspense>
      </>
    );
  }
  return (
    <Route
      path="/*"
      element={<ProtectedRoute>{notFound()}</ProtectedRoute>}
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
